import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '@pages/order-refund-list/action'

const initialState = {
    items: []
}

const reducers = createActions({
    queryRefundDetailAction: {
        success: (state, action) => {
            const { items = [], ...other } = action.payload || {}
			
            return { ...state, ...other, items }
        }
    }
}, actions)

const orderInfoSlice = createSlice({
    name: 'refundInfo',
    initialState,
    ...reducers
})

export default orderInfoSlice
